export const yang = require("./yang.png");
export const canOfFood = require("./Can_of_Food.png");
export const toiletPaper = require("./Toilet_Paper.png");
export const sanitzer = require("./Sanitizer.png");
export const dareth = require("./Dareth_Schamren.png");
